import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismToggle, PrismTooltip } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { gt } from 'ember-truth-helpers';

// Durations maps the length of liveupdates (keys) to duration in minutes (values)
const DURATIONS = {
  45: 5,
  60: 10,
  90: 15,
  180: 20,
  365: 45,
};

interface HotelFormFieldsLiveupdateCheckboxSignature {
  Args: {
    days: unknown;
    hasLiveShop: unknown;
    liveupdateChecked: unknown;
    liveupdateDisabled: unknown;
    onChangeChecked: unknown;
    tooltipText: unknown;
  };
}

export default class HotelFormFieldsLiveupdateCheckbox extends Component<HotelFormFieldsLiveupdateCheckboxSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get exportWithLiveupdate() {
    return this.args.liveupdateChecked && !this.args.liveupdateDisabled;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get liveUpdateAdvice() {
    const length = this.args.days;
    let advice = '';

    Object.keys(DURATIONS).some((limit) => {
      // @ts-expect-error: Incorrect type
      if (length <= limit) {
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const minutes = DURATIONS[limit];
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        advice = this.intl.t('settings.reports.dynamicinfo', { minutes });

        return true;
      }

      return false;
    });

    return advice;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get tooltipText() {
    return (
      this.args.tooltipText ??
      this.intl.t('error.liveupdate.disabled_for_comparison')
    );
  }

  <template>
    <div class="flex flex-col">
      {{#if @hasLiveShop}}
        <div
          data-event-id="custom-export-liveupdate-checkbox"
          data-event-value={{if this.exportWithLiveupdate false true}}
        >
          <span class="ic-product-tour-custom-export-liveupdate flex w-fit">
            <PrismToggle
              {{! @glint-expect-error: Incorrect type }}
              @isChecked={{this.exportWithLiveupdate}}
              {{! @glint-expect-error: Incorrect type }}
              @isDisabled={{@liveupdateDisabled}}
              @label={{t "general.liveupdate"}}
              {{! @glint-expect-error: Incorrect type }}
              @onChange={{@onChangeChecked}}
            />

            {{#if @liveupdateDisabled}}
              {{! @glint-expect-error: Incorrect type }}
              <PrismTooltip @text={{this.tooltipText}} />
            {{/if}}
          </span>
        </div>
        {{#if this.exportWithLiveupdate}}
          <p class="paragraph-300--regular mt-200">
            {{this.liveUpdateAdvice}}
          </p>
          {{#if (gt @days 60)}}
            <p class="text-300--regular mt-200">
              {{t "rates.custom_export.pro_tip"}}
            </p>
          {{/if}}
        {{/if}}
      {{/if}}
    </div>
  </template>
}
